/* eslint-disable no-negated-condition */
import { derived, writable } from "svelte/store";
import { response } from "@stores/global";

export const tests = writable({
  videoend: false
});

// Hides controls until given questions shown if response payload contains
// hideControls flag - useful for instructional text-based video responses
export const hidden = derived([response, tests], ([$response, $tests]) => {
  if (!$response || !$response.payload) {
    return false;
  }

  const features = $response.payload.features || [];

  const controlsToggle = features.find(
    (feature) => feature.type === "hide-controls"
  );

  if (!controlsToggle) {
    return false;
  }

  const { until } = controlsToggle;

  if (typeof $tests[until] !== "undefined") {
    return !$tests[until];
  }

  return false;
});

export const shown = derived(hidden, ($hidden) => !$hidden);
